import { NearestFilter, TextureLoader } from 'three';
import classifications from './textures/colormaps/classifications.png';

// Load classification texture
const loader = new TextureLoader();

export const classificationTexture =
  loader.load(classifications, texture => {
    texture.minFilter = NearestFilter;
    texture.magFilter = NearestFilter;
  });
